import React from 'react'
import css from '@emotion/css'
import JustinDuotone from './JustinDuotone'
import { RegularP, BoldP } from '../about'
import { getEmSize } from '../../styles/mixins'
import { breakpoints } from '../../styles/variables'

export default function FirstSection() {
  return (
    <div
      css={css`
        display: flex;
        margin-top: 70px;
        align-items: flex-start;
        @media (max-width: ${getEmSize(breakpoints.lg)}em) {
          margin-top: 20px;
        }
      `}
    >
      <JustinDuotone
        css={css`
          width: 30%;
          margin-top: -50px;
          @media (max-width: ${getEmSize(breakpoints.lg)}em) {
            display: none;
          }
        `}
        objectPosition="50% 0%"
      />
      <div
        css={css`
          width: 50%;
          padding-left: 100px;
          @media (max-width: ${getEmSize(breakpoints.lg)}em) {
            width: 100%;
            padding-left: 15px;
            padding-right: 15px;
          }
        `}
      >
        <BoldP>
          Our communities are working longer hours for lower wages while corporations make record profits and executives collect
          million-dollar bonuses. Our city has become a playground for the wealthy few while a vast majority of us struggle to pay rent, buy
          groceries, and afford basic healthcare.
        </BoldP>
        <RegularP>
          We are challenging a political system that has catered to corporate interests for decades. We believe that healthcare is a human
          right. We believe that young people should not have to live their entire lives under the burden of student loan debt. We believe
          that all should feel safe and welcome in our country and our communities. We believe that we must end mass incarceration and end
          for-profit prisons. We believe that environmental justice is a defining fight of our generation and it must be led by the
          communities who suffer most from our continued inaction—black, brown, indigenous, and working class.
        </RegularP>
        <RegularP>
          Our country needs a political revolution. We need new leaders who have the courage to step up and join the conversation to
          reimagine entire systems.
        </RegularP>
      </div>
    </div>
  )
}
